// Training sandbox (train.smileseasons.com). me.js marks <html data-training="1"> from
// /__app/me BEFORE the app mounts, so this is right on the first render and outside React.
// Production never sets it.
export function isTraining() {
  return typeof document !== 'undefined' && document.documentElement.dataset.training === '1'
}

// Why no file may be uploaded or deleted there (Ram, 2026-11-01): the Wasabi buckets are
// the live clinic's, and object keys are built from patient / employee ids that the sandbox
// data counts from 1 just as live does — a practice upload lands in a real patient's folder.
// The ENFORCING copy is functions/_middleware.js (TRAINING_FILE_ROUTES + the Wasabi write
// block in installSandboxFetch). These only explain it on screen.
export const TRAINING_FILES_OFF_TH = 'โหมดฝึกอบรม — อัปโหลดและลบไฟล์ไม่ได้'
export const TRAINING_FILES_OFF_DETAIL_TH = 'ที่เก็บไฟล์ใช้ร่วมกับระบบจริง · ในระบบจริงปุ่มนี้ใช้ได้ตามปกติ'
export const TRAINING_DOC_OFF_TH = 'โหมดฝึกอบรม — บันทึกเอกสารเข้าแฟ้มคนไข้ไม่ได้'
